import { get, post, del } from 'aws-amplify/api';

import { CommercialApplication } from '../models/commercial-application.model';
import {
  CreateCommercialApplication,
  CreateCommercialApplicationSchema,
} from '../models/createCommercialApplication.model';
import { format, sub, addDays } from 'date-fns';
import { getUserToken } from './util.service';

export const createCommercialApplication = async (createApplication: CommercialApplication) => {
  const createApplicationBody = mapToRequest(createApplication);
  const response = await post({
    apiName: 'commercialApplications',
    path: '/commercial-applications',
    options: { body: createApplicationBody },
  }).response;
  const json = (await response.body.json()) as any;
  return mapFromResponse(json);
};

export const getCommercialApplications = async (filters: {
  startDate?: string;
  endDate: string;
  name?: string;
  archived?: boolean;
  isPhoneApplication?: boolean;
}): Promise<CommercialApplication[]> => {
  let { startDate, endDate, name, archived, isPhoneApplication } = filters;

  if (!startDate) startDate = format(sub(new Date(), { years: 1 }), 'yyyy-MM-dd');
  if (!endDate) endDate = format(addDays(new Date(), 1), 'yyyy-MM-dd');

  const response = await get({
    apiName: 'commercialApplications',
    path: `/commercial-applications?startDate=${startDate}&endDate=${endDate}&name=${name}&archived=${archived}&isPhoneApplication=${isPhoneApplication}`,
  }).response;
  const json = (await response.body.json()) as any;
  return json.map((a: any) => mapFromResponse(a));
};

export const getCommercialApplication = async (applicationId: string): Promise<CommercialApplication> => {
  const userToken = await getUserToken();
  const response = await get({
    apiName: 'commercialApplications',
    path: `/commercial-applications/${applicationId}`,
    options: { headers: { 'x-auth-token': `Bearer ${userToken}` } },
  }).response;
  const json = (await response.body.json()) as any;
  return mapFromResponse(json);
};

export const deleteCommercialApplication = async (applicationId: string): Promise<void> => {
  await del({ apiName: 'commercialApplications', path: `/commercial-applications/${applicationId}` }).response;
};

export const archiveCommercialApplication = async (applicationId: string): Promise<void> => {
  await post({ apiName: 'commercialApplications', path: `/commercial-applications/${applicationId}/archive` }).response;
};

export const unarchiveCommercialApplication = async (applicationId: string): Promise<void> => {
  await post({ apiName: 'commercialApplications', path: `/commercial-applications/${applicationId}/unarchive` })
    .response;
};

const mapFromResponse = (app: any): CommercialApplication => {
  const res: CommercialApplication = {
    ...app,
    createdAt: new Date(app.createdAt),
    updatedAt: app.updatedAt ? new Date(app.updatedAt) : undefined,
  };
  return res;
};

export class ValidationError extends Error {
  constructor(message: string, public errors: string[]) {
    super(message);
    this.name = 'ValidationError';
  }
}

const mapToRequest = (app: CommercialApplication): CreateCommercialApplication => {
  const resParse = CreateCommercialApplicationSchema.safeParse(app);
  if (resParse.success) {
    return resParse.data;
  }

  console.log(resParse.error);
  // ZodError: [
  //   {
  //     code: "too_big",
  //     maximum: 11,
  //     type: "number",
  //     inclusive: true,
  //     exact: false,
  //     message: "Number must be less than or equal to 11",
  //     path: ["previousMonthsAtAddress"],
  //   },
  //   {
  //     code: "too_big",
  //     maximum: 11,
  //     type: "number",
  //     inclusive: true,
  //     exact: false,
  //     message: "Number must be less than or equal to 11",
  //     path: ["coapplicantPreviousEmployedMonths"],
  //   },
  // ];
  const errorMessages = resParse.error.issues.map((error: any) => `${error.path[0]}: ${error.message}`);
  throw new ValidationError('Validation error', errorMessages);
};
